/**
 * @name splitText.js
 * @description テキストを1文字ずつ分割してspanタグで囲む
 */

const splitText = () => {

    /**
     * @name splitText
     * @param {*} el 
     */
    const splitText = (el) => {
        const text = el.textContent;
        const split = text.split('');
        const wrap = split.map((t, i) => {
            return `<span aria-hidden="true" translate="no" style="transition-delay: ${i * 0.01}s;">${t}</span>`;
        }).join('');
        el.innerHTML = wrap;
    }

    /**
     * @name splitTexts
     */
    const splitTexts = () => {
        const splitTexts = document.querySelectorAll('.js-splitText');
        splitTexts.forEach((el) => {
            splitText(el);
            el.classList.remove('js-splitText');
        });
    }

    splitTexts();
}

export default splitText;